<div class="row">
  <div class="col-lg-12">
    <div class="rating-card-static d-flex flex-column align-items-center">
      @if (image()) {
        <img class="img-responsive w-100"
          [src]="image() | imageUrl:imageTransformations"
          [alt]="image()?.alt_text ?? titleText">
      }
      @if (!image()) {
        <img class="img-responsive w-100"
          [src]="imageUrl ? imageUrl : fallbackImage"
          [alt]="titleText">
      }
      <p class="h5 name font-weight-bold">
        {{titleText}}
      </p>
      <p class="position text-muted">
        {{subtitleText}}
      </p>
      <p class="rating-value h1 font-weight-bold mb-0">
        {{score}}
      </p>
    </div>
  </div>

</div>